import 'react-multi-carousel/lib/styles.css';
import { Container, Row, Col } from "react-bootstrap";
import CodeBlock from "./CodeBlock";
import { useState, useEffect } from "react";

export const AboutMe = () => {
    const images = [
        "/files/img/about-me/diploma.jpg",
        "/files/img/about-me/disney.jpg",
        "/files/img/about-me/oostenrijk.jpg",
        "/files/img/about-me/comic-con-2023.jpeg",
    ];

    const [currentIndex, setCurrentIndex] = useState(0);
    const [nextIndex, setNextIndex] = useState(1);
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        const interval = setInterval(() => {
            setIsAnimating(true);
            setTimeout(() => {
                setCurrentIndex(nextIndex);
                setNextIndex((nextIndex + 1) % images.length);
                setIsAnimating(false);
            }, 800);
        }, 5000);
        return () => clearInterval(interval);
    }, [nextIndex, images.length]);

    return (
        <section className="about-me" id="about-me">
            <Container>
                <Row>
                    <Col
                        xs={{ order: 2 }}
                        md={{ order: 2 }}
                        xl={{ order: 1, span: 5 }}
                        className="d-flex align-items-center justify-content-center"
                    >
                        <div className="about-me-bx text-center mt-5 mt-xl-0">
                            <div className="glitch-frame">
                                <img
                                    src={images[currentIndex]}
                                    alt="About me"
                                    className={`slide-image current ${isAnimating ? "slide-out" : ""}`}
                                />
                                <img
                                    src={images[nextIndex]}
                                    alt="About me next"
                                    className={`slide-image next ${isAnimating ? "slide-in" : ""}`}
                                />
                            </div>

                            <div className="mt-3">
                                <button
                                    className="me-4"
                                    onClick={() =>
                                        window.open("/documents/CV_Jennifer_Coenraad.pdf", "_blank", "noopener,noreferrer")
                                    }
                                >
                                    <span>Download mijn CV</span>
                                </button>
                            </div>
                        </div>
                    </Col>

                    <Col xs={{ order: 1 }} md={{ order: 1 }} xl={{ order: 2, span: 7 }}>
                        <div className="about-me-bx">
                            <h4>Wie ben ik?</h4>
                            <CodeBlock />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};
